<svg xmlns="http://www.w3.org/2000/svg" width="32" height="26" viewBox="0 0 32 26">
  <g fill="none" fill-rule="evenodd">
    <g>
      <rect width="32" height="25.6" fill="#AAEBCE" rx="1.6"/>
      <path fill="#3DD7AB" d="M1.6 0h28.8A1.6 1.6 0 0 1 32 1.6v1.6H0V1.6A1.6 1.6 0 0 1 1.6 0z"/>
    </g>
    <g fill="#3DD7AB">
      <path d="M18.367 7.435a.2.2 0 0 0-.33-.152l-4.16 3.565a.2.2 0 0 0 0 .304l4.16 3.565a.2.2 0 0 0 .33-.152V12.6h8.7a.3.3 0 0 0 .3-.3V9.7a.3.3 0 0 0-.3-.3h-8.7V7.435zM13.633 13.435a.2.2 0 0 1 .33-.152l4.16 3.565a.2.2 0 0 1 0 .304l-4.16 3.565a.2.2 0 0 1-.33-.152V18.6h-8.7a.3.3 0 0 1-.3-.3v-2.6a.3.3 0 0 1 .3-.3h8.7v-1.965z"/>
    </g>
  </g>
</svg>
